export default {
  changeMenu(state) {
    //console.log(state.menuVisibility ? 'Close' : 'Open','modal',)
    document.body.classList.toggle("modal-open");
    state.menuVisibility = !state.menuVisibility
  },

  updateMenuMut(state, proyectos) {
    let sublinks = [];
      //console.log(proyectos)
      proyectos.forEach(proyecto => {
        if (proyecto.link != ''){
          //console.log(proyecto.link)
          sublinks.push(        
            {
              ruta: proyecto.link,
              icon: false,
              fullpath: true,
              nombre: proyecto.nombre,
              isMovilActive: true,
              style: { fontSize: '10px'},
              mode: " hover:text-azul"  
            }  
          )  
        }else {
          //console.log(proyecto.link)
          sublinks.push(        
            {
              ruta: state.rooturl + state.subcarpeta +'/caminos/'+ proyecto.slug,
              icon: false,
              fullpath: true,
              nombre: proyecto.nombre,
              isMovilActive: true,
              style: { fontSize: '10px'},
              mode: " hover:text-azul"  
            }  
          )  
        } 
      });

      let sublinksPatas =  [
        {
          ruta: state.rooturl + state.subcarpeta +'/recreacion/recreacion-comunitaria',
          icon: false,
          nombre: "LA RECREACIÓN COMUNITARIA",
          isMovilActive: true,
          fullpath: true,
          style: { fontSize: '10px'},
          mode: " hover:text-azul"                
        },
        {
          ruta: state.rooturl + state.subcarpeta +'/recreacion/la-ludica',
          icon: false,
          nombre: "LA LÚDICA, EL JUEGO, EL JUGAR",
          isMovilActive: true,
          fullpath: true,
          style: { fontSize: '10px'},
          mode: " hover:text-azul"
        },
        {
          ruta: state.rooturl + state.subcarpeta +'/recreacion/educacion-popular',
          icon: false,
          nombre: "EDUCACIÓN POPULAR",
          isMovilActive: true,
          fullpath: true,
          style: { fontSize: '10px'},
          mode: " hover:text-azul"
        },
      ]
    //console.log(state.menulinks)
    // console.log(state.rooturl + state.subcarpeta)
    // console.log(sublinks)
    // console.log(sublinksPatas)
    state.menulinks[4].sublinks = sublinks;
    state.menulinks[2].sublinks = sublinksPatas;    
    state.proyectoslinks[3].sublinks = sublinks;
    state.proyectoslinks[2].sublinks = sublinksPatas;
    state.novedadeslinks[3].sublinks = sublinks;
    state.novedadeslinks[2].sublinks = sublinksPatas;
    //console.log(state.proyectoslinks)
  },

  changeWindowView(state, movilView){
    //console.log('changeWindowView')
    state.mobileView = movilView;
  },

  changeScroll(state, scroll) {
    state.scrollD = scroll;
  },

  handleVisibility(state) {
    //console.log("movil:" + state.mobileView)
    if (window.innerWidth < 769) {      
      state.mobileView = true
    } else {
      var orientation = (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){            
        // true for mobile device      
        if (orientation == 'landscape-primary'){
          state.mobileLandscape = true
        } else {
          state.mobileLandscape = false
        }
      } else{
        // false for not mobile device
        state.mobileLandscape = false
      }
      if (state.mobileLandscape == true){
        state.mobileView = true
      } else {
        state.mobileView = false
        if (state.menuVisibility == true) {
          //console.log('cierro modal')
          state.menuVisibility = false
          document.body.classList.remove("modal-open");
        }
        if (window.innerWidth < 1300) {
          state.ultrawideView = false
        } else {
          state.ultrawideView = true
        }
      }
    }
  },

  handleOrientation(state) {
    //console.log('handleOrientation');
    var orientation = (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;
    
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){            
      // true for mobile device      
      if (orientation == 'landscape-primary'){
        state.mobileLandscape = true
      } else {
        state.mobileLandscape = false
      }
    } else{
      // false for not mobile device
      state.mobileLandscape = false
    }
      
  },

  closeMenu(state) {
    //console.log('cierro modal')
    document.body.classList.remove("modal-open");
    state.menuVisibility = false
    //console.log('cerrarMenu')
  },
}